module.exports = __webpack_public_path__ + "img/vie.60d8169b.jpg";